import React from 'react';
import WebSelect from './Select';
import MobileSelect from './MobileSelect';
import { isMobile } from 'react-device-detect';

export default React.forwardRef((props, ref) => {
  if (isMobile) {
    return <MobileSelect ref={ref} {...props} />;
  }
  return <WebSelect ref={ref} {...props} />;
});
